import React from "react";
import LinkHandler from "./LinkHandler";

export const Services = (props) => {
  return (
    <div className="services text-center">
      <div className="container">
        <div className="section-title">
          <h2>Что входит в наши услуги?</h2>
          <h3>Реставрация лифтов и металлов: шлифовка, полировка, удаление дефектов</h3>
          <p>Профессиональные услуги по шлифовке, полировке и реставрации металлических конструкций из <strong>нержавеющей стали</strong>, <strong>алюминия</strong>, <strong>меди</strong>, <strong>латуни</strong> и других металлов.</p>
          <p><LinkHandler href="/" title="Пролистать на главную (на самый верх)">Мы</LinkHandler> устраняем дефекты, восстанавливаем блеск и текстуру, обеспечиваем долговечность и стильный вид <strong>лифтовых кабин</strong> и других <strong>металлических поверхностей</strong>.</p>
          <p>Ознакомьтесь с примерами наших работ и убедитесь в качестве реставрации в нашем <LinkHandler href="/restoration-portfolio" title="Пролистать к разделу с портфолио">портфолио</LinkHandler>. Мы гордимся результатами и готовы помочь вам вернуть металлам их первозданный вид.</p>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      props.onOpenModal(d.name, d.text, d.desc, d.img, d.alt, d.price);
                    }}
                  >
                    <img src={d.img} alt={d.alt} />
                    <div className="service-desc">
                      <h3>{d.name}</h3>
                      <p>{d.text}</p>
                      <div className="service-price">
                        <p>{d.price}</p>
                      </div>
                    </div>
                  </a>
                </div>
              ))
            : "Загрузка"}
        </div>
      </div>
    </div>
  );
};